import { render, staticRenderFns } from "./UpdateFund.vue?vue&type=template&id=130dcbe2&scoped=true"
import script from "./UpdateFund.vue?vue&type=script&lang=js"
export * from "./UpdateFund.vue?vue&type=script&lang=js"
import style0 from "./UpdateFund.vue?vue&type=style&index=0&id=130dcbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dcbe2",
  null
  
)

export default component.exports